export const publicPath = (filePath: string): string =>
  `${process.env.PUBLIC_URL}/${filePath}`;
